import { z } from "zod";
import { zStringId, zTimestamps } from "../../utils";
import { zLocation } from "../users/user-resource";

export const zOrder = z.object({
  _id: zStringId(),
  orderNumber: z.number(),
  total: z.number(),
  totalTax: z.number(),
  subtotalTaxExclusive: z.number(),
  items: z
    .object({
      serviceProjectDoc: z.object({
        serviceDetails: z.object({
          title: z.string(),
        }),
        professionalDoc: z.object({
          firstName: z.string(),
          lastName: z.string(),
        }),
      }),
      servicePackagePrice: z.number(),
      tax: z.number(),
      itemTotalTaxExclusive: z.number(),
      amountCaptured: z.boolean().optional(),
      paymentTransactionId: z.string().optional(),
      itemProcessed: z.boolean().optional(),
    })
    .array(),
  userDoc: z.object({
    firstName: z.string(),
    lastName: z.string(),
    phoneNumber: z
      .object({
        type: z.object({
          code: z.string(),
          number: z.string(),
        }),
      })
      .optional(),
    billingAddress: zLocation.optional(),
  }),
  ...zTimestamps(),
});

export type Order = z.infer<typeof zOrder>;
